import axios from 'axios'
import {orderBy} from 'lodash'
import {asResponse} from '../util'
import {mutate} from 'swr'

export const SERVICES_SWR_KEY = '/bff/services?load=versions[{"projection": {"conflicts": 0}}]&limit=1000'

export const getServices = async (url) => {
  const resp = await asResponse(axios.get(url))
  let services = resp.data ? (resp.data.results || []) : []
  services = orderBy(services.map(s => {
    s.lowerCaseName = s.name.toLowerCase()
    return s
  }), ['lowerCaseName', 'asc'])
  return {services}
}

export const mutateServices = async function () {
  let args = Array.from(arguments)
  args = [SERVICES_SWR_KEY, ...args]
  return mutate.apply(this, args)
}

export const SERVICE_SWR_KEY = ({serviceId}) => [`/bff/services/${serviceId}?load=versions[{"options":{"sort": {"createdAt":-1}}}]`, serviceId]

export const getService = async (url, serviceId) => {
  if (!serviceId) {
    return {
      service: undefined
    }
  }
  const resp = await asResponse(axios.get(url.replace('${serviceId}', serviceId)))
  const service = resp.data
  return {
    service
  }
}

export const getServiceById = async (serviceId) => {
  const resp = await asResponse(axios.get(`/bff/services/${serviceId}`))
  return resp.data
}

export const mutateService = async function () {
  let args = Array.from(arguments)
  const serviceId = args[args.length - 1]
  const key = SERVICE_SWR_KEY({serviceId})
  args = [key, ...args]
  return mutate.apply(this, args)
}


export const COPY_TO_SERVICE_SWR_KEY = ({copyToServiceId}) => [`/bff/services/${copyToServiceId}?load=versions.environments.resources`, copyToServiceId]

export const getCopyToService = async (url, copyToServiceId) => {
  if (!copyToServiceId) {
    return {
      copyToService: undefined
    }
  }
  const resp = await asResponse(axios.get(url.replace('${copyToServiceId}', copyToServiceId)))
  const copyToService = resp.data
  return {
    copyToService
  }
}

export const mutateCopyToService = async function () {
  let args = Array.from(arguments)
  const copyToServiceId = args[args.length - 1]
  const key = SERVICE_SWR_KEY({copyToServiceId})
  args = [key, ...args]
  return mutate.apply(this, args)
}

export const cloneService = async (serviceId) => {
  const resp = await asResponse(axios.post(`/bff/services/clone`, {id: serviceId}))
  return resp.data
}

export const upsertService = async (service) => {
  const verb = service.id ? 'put' : 'post'
  const path = service.id ? `/bff/services/${service.id}` : `/bff/services`
  const resp = await asResponse(axios[verb](`${path}?buildDefaultVersion=true`, service))
  return resp.data
}

export const uploadService = async (contract) => {
  const resp = await asResponse(axios.post(
    '/bff/services/upload-contract',
    contract.definition,
    {
      headers: {
        'Content-Type': 'text/plain'
      }
    }
  ))
  return resp.data
}

export const archiveService = async (serviceId) => {
  const resp = await asResponse(axios.post('/bff/services/archive', {serviceId}))
  return resp.data
}

export const removeService = async (serviceId) => {
  return asResponse(axios.delete(`/bff/services/${serviceId}`))
}